<template>
  <div>
    <Bubble>
      <!-- <router-view></router-view> -->
      <div class="row">
        <div class="col">
          <Typo>
            <template slot="header">Einstimmiger Beschluss des Räumliches Leitbildes</template>
            <template slot="main">zum Jahresende</template>
          </Typo>
        </div>
        <div class="col-3-center">
          <p>Der Stadtrat hat mit einstimmigem Beschluss in der Sitzung am 10.12.2019 das Räumliche Leitbild als Grundlage für den neuen Flächennutzungsplan beschlossen.</p>
          <p>Die umfragereichen Ergebnisse der intensiven Beteiligung der Arbeitsgruppen, Bürger, Verwaltung und der Stadträte wurden nochmals im Foyer des Rathauses als Ausstellung aufgebaut.</p>
          <div>
            <img
              style="width: 100%; padding:0"
              src="@/assets/fotos_presse/austellung_rathaus.jpg"
              alt="Austellung Rathaus"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Typo>
            <template slot="header">UMSETZUNG DES PARKLETS</template>
            <template slot="main">IN DER MÜNCHNER STRASSE</template>
          </Typo>
        </div>
        <div class="col-3-center">
          <p>Seit dem 30.07.2019 ersetzt das Parklet 2 Parkplätze in der Münchner Straße und bietet dem Leitgedanken der Flanierstadt Raum und Angebot. Ein Parklet wandelt einen Parkplatz in eine kleine Flanier-Station mit Wohlfühlfaktor um und zeigt »Dachau denkt weiter!« Ob Minigarten, Sitzlandschaft oder einfach nur ein paar Fahrradbügel – auf einem Parklet ist viel Platz für Kreative Ideen. Das Projekt entstand in kürzester Zeit, angeregt durch die vielen Beiträge der Bürger zum Thema Mobilität.</p>
          <p>Der Ideenbaum bietet Raum für eigene Botschaften zur Mobiliät. Hierbei ­sollten nicht nur Forderungen an die Stadt gestellt werden, sondern auch das eigene Mobilitätsverhalten reflektiert werden.</p>
          <p>Nun kann und soll auch vom Bürger selbst eine Mobilitätsveränderung ­erbracht werden und an dem Baum als Ansatz hinterlassen werden.</p>
          <div>
            <Gallery :items="serie4" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Typo>
            <template slot="header">ÜBER DEN BÜRGERWORKSHOP</template>
            <template slot="main">IN DER ZENTRALWERKSTATT</template>
          </Typo>
        </div>
        <div class="col-3-center">
          <p>Rund 300 Bürger informierten und beteiligten sich intensiv am Bürgerworkshop in der Zentralwerkstatt des MD-Areals. Nach der Begrüßung durch den Oberbürgermeister Florian Hartmann folgte ein kurzer Einführungsfilm, der den bisherigen Prozess dokumentierte und Beiträge einzelner Arbeitsgruppenmitglieder zu den Zukunftsbildern Dachaus zeigte. Im Stadtlabor konnten die Bürger – neben der Möglichkeit Collagen und Leitgedanken der Arbeitsgruppe zu kommentieren – Strukturen im Flächennutzungsplan zeichnerisch ergänzen und Impulsmaßnahmen benennen. Zwei Fachvorträge zum Thema Coworking und gesellschaftliche Teilhabe ergänzten das Beteiligungsprogramm. Einen stimmigen Ausklang bot der Dachauer Multipercussionist Christian F. Benning.</p>
          <div>
            <Gallery :items="serie3" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Typo>
            <template slot="header">DACHAU WEITER DENKEN</template>
            <template slot="main">BÜRGER-WORKSHOP AM 27.07.2019</template>
          </Typo>
        </div>
        <div class="col-3-center">
          <h2>DACHAU WEITER DENKEN</h2>
          <p>IM BÜRGER-WORKSHOP AM 27.07.19 PRÄSENTIERT DIE STADT ZUM EINEN BEREITS ERARBEITETE IDEEN UND ANSÄTZE, ZUM ANDEREN GILT ES:</p>
          <p>LEITBILDER WEITER DENKEN – SIE SIND HERZLICH EINGELADEN, IHRE ANREGUNGEN UND IDEEN EINZUBRINGEN.</p>
          <p>Wie soll sich unsere Stadt in den kommenden Jahrzehnten entwickeln? Diese Frage geht uns alle etwas an. Deshalb wollen wir die Antworten auf diese Frage gemeinsam mit Ihnen finden.</p>
          <p>Wir wollen ein so genanntes räumliches Leitbild entwerfen, das der Stadtpolitik Orientierung gibt und auf dessen Grundlage wir in Zukunft Entscheidungen treffen können. Helfen Sie uns dabei, indem Sie sich, Ihre Ideen und Vorstellungen mit einbringen. Denn es ist Ihre Stadt, Ihre Heimat, Ihre Zukunft.</p>
          <p>
            <b>PROGRAMM BÜRGER-WORKSHOP AM 27.07.19</b>
          </p>
          <p>
            <b>11.30 UHR</b>
            <br />
            <b>ERÖFFNUNG DES WORKSHOPS</b>
            <br />durch den Oberbürgermeister Florian Hartmann
          </p>
          <p>
            <b>11.40 UHR</b>
            <br />
            <b>FILM-DOKUMENTATION</b>
            <br />den Projektfortschritt erleben
          </p>
          <p>
            <b>12.00 UHR</b>
            <br />
            <b>EINFÜHRUNG BÜRGERWORKSHOP</b>
            <br />durch den Stadtbaumeister Moritz Reinhold & Vorstellung der einzelnen Stationen.
          </p>
          <p>
            <b>12.15 UHR</b>
            <br />
            <b>MARKTPLATZ DER IDEEN I</b>
            <br />Leitbilder weiter denken – z.B. im Stadt-Labor, an der interaktiven GrünKarte, an den Profiltischen oder in der Kinderstadt.
          </p>
          <p>
            <b>13.15 UHR</b>
            <br />
            <b>FACHVORTRAG I</b>
            <br />Hans-Peter Sander »die unterneh­merische Stadt« – Welche Möglich­keiten gibt es für den Arbeitsplatz von morgen?
          </p>
          <p>
            <b>13.45 UHR</b>
            <br />
            <b>MARKTPLATZ DER IDEEN II</b>
            <br />Leitbilder weiter denken – z.B. im Stadt-Labor, an der interaktiven GrünKarte, an den Profiltischen oder in der Kinderstadt.
          </p>
          <p>
            <b>14.45 UHR</b>
            <br />
            <b>FACHVORTRAG II</b>
            <br />Angela Ljiljanic »Stadtwirte – von Sozialraumfarmern und Inklu­sionswirten«: Soziale Integration, Teilhabe und Bürgerprojekte. Atlas »Stadtwirte« führt uns zu Menschen und an Orte, die etwas haben, was die anderen nicht haben und die etwas machen, was gemacht werden muss: Expansion durch Inspiration, inklusive Inklusion!
          </p>
          <p>
            <b>15.15 UHR</b>
            <br />
            <b>MARKTPLATZ DER IDEEN III</b>
            <br />Leitbilder weiter denken – z.B. im Stadt-Labor, an der interaktiven Grün-Karte, an den Profiltischen oder in der Kinderstadt.
          </p>
          <p>
            <b>16.15 UHR</b>
            <br />
            <b>FISHBOWL</b>
            <br />Offene Diskussionsrunde
            <br />Moderation durch Prof. Peter Dürr
          </p>
          <p>
            <b>17.00–18.30 UHR</b>
            <br />
            <b>ABSCHLUSS</b>
            <br />Musik & Abschlussfest
          </p>
          <p>
            <b>VERANSTALTUNGSORT</b>
            <br />Der Bürgerworkshop findet gezielt in der Zentralwerkstatt des MD-Areals statt. Das MD-Areal ist eines der größten Entwicklungsareale der Stadt Dachau und wird in Zukunft einen wichtigen, neuen, urbanen Raum in der Stadt entfalten.
          </p>
          <p>
            <b>VERANSTALTER</b>
            <br />GROSSE KREISSTADT DACHAU
            <br />Konrad-Adenauer-Straße 2–6
            <br />D-85221 Dachau
            <br />
            <a href="https://www.dachau.de" target="_blank">www.dachau.de</a>
          </p>
          <p>
            <b>KONZEPTION</b>
            <br />
            <a href="http://www.diestadtentwickler.com" target="_blank">www.diestadtentwickler.com</a>
          </p>
          <p>
            <b>PROGRAMM ZUM DOWNLOAD</b>
            <br />
            <a
              href="../static/dokumente/flyer_bürgerworkshop.pdf"
              download
            >www.flyer_bürgerworkshop.pdf</a>
          </p>
          <img :src="require('@/assets/grafiken/aktuelles/lageplan.png')" alt />
          <img :src="require('@/assets/grafiken/aktuelles/programm.png')" alt />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Typo>
            <template slot="header">03.06.2019</template>
            <template slot="main">PROFILWERKSTATT "DACHAU DENKT WEITER"</template>
          </Typo>
        </div>
        <div class="col-3-center">
          <h2>PROFILWERKSTATT "DACHAU DENKT WEITER"</h2>
          <p>In der »Etappe II« wurden aus Stadtrat, Verwaltung und unterschiedlichen Interessensverbänden eine Arbeitsgruppe zur Erarbeitung der Leitziele des Leitbildes gebildet.</p>
          <p>Am 30.04.2019 hatten die vom Bau- und Planungsausschuss ausgewählten Arbeitsgruppenmitglieder im Rahmen eines Workshops die Gelegenheit, ihre Ideen zur Gestaltung ihres Lebensumfeldes einzubringen. Auf vorbereiteten Profiltischen konnten sie die Wünsche und Vorstellungen zu insgesamt neun Themen als Bildcollagen gestalten.</p>
          <p>Einige der Anregungen wurden mehrfach bei verschiedenen Themenfeldern geäußert, was umso mehr ihre Bedeutung unterstreicht.</p>
          <p>Diese Leitgedanken werden durch den geplanten Bürgerworkshop der gesamten Stadtgesellschaft vorgestellt und weitere Anregungen, Anmerkungen und Diskurs ergänzt werden. Vorab findet bis zum Bürgerworkshop noch eine Online-Beteiligung über die Projektinternetseite statt. Nach der Zusammenfassung aller Anregungen werden die bisherigen Ergebnisse als Grundlage für einen Entwurf des Leitbildes herangezogen und auch räumliche Bezüge hergestellt.</p>
          <div>
            <Gallery :items="serie2" />
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <Gallery :items="serie2"/>
      </div>-->
      <div class="row">
        <div class="col">
          <Typo>
            <template slot="header">14.11.2018</template>
            <template slot="main">Interaktive Karte intensiv genutzt</template>
          </Typo>
        </div>
        <div class="col-3-center">
          <h2>Interaktive Karte intensiv genutzt</h2>
          <p>
            Der Kurier Dachau berichtet über den Zwischenstand bei der Nutzung der „Interaktiven Karte“ durch
            Bürgerinnen und Bürger.
          </p>
          <p>
            Zum Artikel geht es
            <a
              href="http://www.kurier-dachau.de/nachrichten/dachau/R%C3%A4umliches+Leitbild+f%C3%BCr+Dachau,23353.html"
              target="blank"
            >hier</a>.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Typo>
            <template slot="header">25.09.2018</template>
            <template slot="main">Auftakt-Workshop "Dachau Denkt Weiter"</template>
          </Typo>
        </div>
        <div class="col-3-center">
          <div>
            <h2>Räumliches Leitbild: Gemeinsamer Start-Workshop mit Stadtrat und Stadtverwaltung</h2>
            <p>
              Die inhaltliche Ausgestaltung von räumlichen Leitbildern in der Stadtentwicklung kann höchst
              unterschiedlich sein. Diese Erfahrung verdeutlichte Stadtplanerin Annegret Michler in ihrem
              Einführungsvortrag am 25.9.2018. Um die Zielvorstellungen und Anforderungen an den Leitbild-Prozess für
              Dachau bereits in einer frühen Phase abzustimmen, hat Oberbürgermeister Florian Hartmann zu einem
              gemeinsamen Workshop eingeladen. Rund 30 Mitglieder des Stadtrates und Mitarbeiter der Stadtverwaltung
              aus den unterschiedlichen Ämtern sind der Einladung gefolgt und haben gemeinsam mit Annegret Michler und
              Dr. Stefan Leuninger sowohl Zielsetzungen und Erwartungen an den Leitbild-Prozess erarbeitet sowie
              Anregungen und Hinweise zu wichtigen Handlungsfeldern in der Großen Kreisstadt Dachau aufgenommen. Die
              fixierten Erwartungen, Wünsche und Zielvorstellungen an den Leitbild-Prozess sind wie folgt dokumentiert
              worden:
            </p>
            <ul>
              <li>Kein Verlust der Lebensqualität in Dachau</li>
              <li>Grundkonsens zum Thema Wachstum früh im Gremium klären</li>
              <li>Abwägung der unterschiedlichen Interessengruppen der Stadt</li>
              <li>Wachstum/Bevölkerungszahlen als wichtiges Basisthema</li>
              <li>transparente Klärung der Widersprüche bzw. Gegensätze</li>
              <li>Wie entwickeln wir die Ortsteile?</li>
              <li>Integration auch der sozialen Aspekte in der Leitbild-Entwicklung</li>
              <li>Kritische Betrachtung bestehender Leitbilder in den Fachplanungen (ggf. Neubewertung)</li>
              <li>Entwicklung des Handwerkzeugs, um eine Stadt der kurzen Wege aufzubauen</li>
            </ul>
            <p>Wünsche und Anregungen an den Prozess:</p>
            <ul>
              <li>Phasenorientiertes Vorgehen mit konkreten Zwischenergebnissen</li>
              <li>Erarbeitung eines verbindlichen Konsenses (unabhängig der politischen Mehrheiten)</li>
              <li>transparente Klärung des Projektziels „räumliches Leitbild“</li>
              <li>keine Erwartungshaltungen wecken, die nicht gehalten werden können</li>
              <li>Denken in fachlichen Schichten</li>
              <li>lebendige Diskussion zu den Themen, weniger zum Verfahren</li>
            </ul>
            <p>
              Für das beauftragte Büro LEUNINGER & MICHLER stellen die zusammengetragenen Erwartungen an das Ergebnis
              und den Prozess eine zentrale Handlungsanweisung für die kommenden 18 Monate dar. Über Zwischenergebnisse
              wird der zuständige Ausschuss für Planung und Bauen in einem regelmäßigen Turnus informiert.
            </p>
            <div>
              <Gallery :items="serie1" />
            </div>
          </div>
        </div>
      </div>
    </Bubble>
  </div>
</template>

<script>
import Gallery from "@/components/Gallery.vue";
export default {
  metaInfo: {
    title: "Aktuelles"
  },
  components: {
    Gallery
  },
  // name: "bilder",
  data() {
    return {
      swiperOption: {},
      serie4: [
        { src: require("@/assets/fotos_presse/parklett/img1.jpg") },
        { src: require("@/assets/fotos_presse/parklett/img2.jpg") },
        { src: require("@/assets/fotos_presse/parklett/img3.jpg") }
      ],
      serie3: [
        {
          src: require("@/assets/fotos_presse/buergerworkshop/img2.jpg")
        },
        { src: require("@/assets/fotos_presse/buergerworkshop/img3.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img5.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img6.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img7.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img8.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img9.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img10.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img11.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img12.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img13.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img14.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img15.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img16.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img17.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img18.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img19.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img20.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img21.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img22.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img23.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img24.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img25.jpg") },
        { src: require("@/assets/fotos_presse/buergerworkshop/img26.jpg") }
      ],
      serie2: [
        {
          id: 1,
          src: require("../assets/fotos_presse/profilwerkstatt/img1.jpg")
        },
        {
          id: 2,
          src: require("../assets/fotos_presse/profilwerkstatt/img2.jpg")
        },
        {
          id: 3,
          src: require("../assets/fotos_presse/profilwerkstatt/img3.jpg")
        },
        {
          id: 4,
          src: require("../assets/fotos_presse/profilwerkstatt/img4.jpg")
        },
        {
          id: 5,
          src: require("../assets/fotos_presse/profilwerkstatt/img5.jpg")
        },
        {
          id: 6,
          src: require("../assets/fotos_presse/profilwerkstatt/img6.jpg")
        },
        {
          id: 7,
          src: require("../assets/fotos_presse/profilwerkstatt/img7.jpg")
        },
        {
          id: 8,
          src: require("../assets/fotos_presse/profilwerkstatt/img8.jpg")
        },
        {
          id: 9,
          src: require("../assets/fotos_presse/profilwerkstatt/img9.jpg")
        },
        {
          id: 10,
          src: require("../assets/fotos_presse/profilwerkstatt/img10.jpg")
        },
        // {
        //   id: 11,
        //   src: require("../assets/fotos_presse/profilwerkstatt/img11.jpg")
        // },
        {
          id: 12,
          src: require("../assets/fotos_presse/profilwerkstatt/img12.jpg")
        },
        {
          id: 13,
          src: require("../assets/fotos_presse/profilwerkstatt/img13.jpg")
        },
        {
          id: 14,
          src: require("../assets/fotos_presse/profilwerkstatt/img14.jpg")
        },
        {
          id: 15,
          src: require("../assets/fotos_presse/profilwerkstatt/img15.jpg")
        },
        {
          id: 16,
          src: require("../assets/fotos_presse/profilwerkstatt/img16.jpg")
        },
        {
          id: 17,
          src: require("../assets/fotos_presse/profilwerkstatt/img17.jpg")
        },
        {
          id: 18,
          src: require("../assets/fotos_presse/profilwerkstatt/img18.jpg")
        },
        {
          id: 19,
          src: require("../assets/fotos_presse/profilwerkstatt/img19.jpg")
        },
        {
          id: 20,
          src: require("../assets/fotos_presse/profilwerkstatt/img20.jpg")
        }
      ],
      serie1: [
        {
          id: 1,
          src: require("../assets/fotos_presse/auftaktworkshop/img1.jpg")
        },
        {
          id: 2,
          src: require("../assets/fotos_presse/auftaktworkshop/img2.jpg")
        },
        {
          id: 3,
          src: require("../assets/fotos_presse/auftaktworkshop/img3.jpg")
        },
        {
          id: 4,
          src: require("../assets/fotos_presse/auftaktworkshop/img4.jpg")
        },
        {
          id: 5,
          src: require("../assets/fotos_presse/auftaktworkshop/img5.jpg")
        },
        {
          id: 6,
          src: require("../assets/fotos_presse/auftaktworkshop/img6.jpg")
        },
        {
          id: 7,
          src: require("../assets/fotos_presse/auftaktworkshop/img7.jpg")
        },
        {
          id: 8,
          src: require("../assets/fotos_presse/auftaktworkshop/img8.jpg")
        },
        {
          id: 9,
          src: require("../assets/fotos_presse/auftaktworkshop/img9.jpg")
        },
        {
          id: 10,
          src: require("../assets/fotos_presse/auftaktworkshop/img10.jpg")
        },
        {
          id: 11,
          src: require("../assets/fotos_presse/auftaktworkshop/img11.jpg")
        },
        {
          id: 12,
          src: require("../assets/fotos_presse/auftaktworkshop/img12.jpg")
        }
      ]
    };
  }
};
</script>


<style scoped lang="scss">
.small {
  display: block;
}

.big {
  display: none;
}

img {
  width: 100%;
  padding: 5px;
}

.thumbnails {
  display: flex;
  flex-wrap: wrap;

  label {
    // margin-top: 10px;
  }

  img {
    padding: 5px;
    width: 50%;
    height: 125px;
    object-fit: cover;
    opacity: 0.7;

    &.active {
      opacity: 1;
    }

    &:hover {
      opacity: 1;
      cursor: pointer;
    }
  }
}

@media (min-width: 768px) {
  .small {
    display: none;
  }

  .big {
    display: inherit;
  }

  .thumbnails {
    img {
      width: 25%;
    }
  }
}

//Transition fade
.delay-enter-active,
.delay-leave-active {
  transition: fade 0.3s;
  transition-delay: 0.5s;
}

.delay-enter,
.delay-leave {
  opacity: 1;
}

@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

ul li {
  margin: 0.3rem;
}

p {
  a {
    text-transform: lowercase;
  }
}
</style>